var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.283 10.3561H11.956V13.8071H16.748C16.302 16.0001 14.435 17.2601 11.956 17.2601C9.03297 17.2601 6.67697 14.9041 6.67697 11.9801C6.67697 9.05712 9.03297 6.70112 11.956 6.70112C13.215 6.70112 14.353 7.14812 15.246 7.87912L17.846 5.28012C16.262 3.89912 14.231 3.04712 11.956 3.04712C7.00197 3.04712 3.02197 7.02612 3.02197 11.9811C3.02197 16.9361 7.00097 20.9151 11.956 20.9151C16.423 20.9151 20.485 17.6661 20.485 11.9811C20.485 11.4531 20.404 10.8841 20.283 10.3561Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandGoogle);
export default __webpack_public_path__ + "static/media/brand_google.324fc7e7665878664f1f3afa007ef237.svg";
export { ForwardRef as ReactComponent };